<template>
  <v-col cols="12" md="12" xl="12" class="py-0 my-2">
    <task
      v-for="(task, index) in events"
      :task="task"
      :history="history"
      :key="task.uniqueId"
      :show-header="index === 0 ? true : false"
      :go-to-profile="goToPartProfile"
      @doneTask="handleDoneTask"
      @deleteOneTask="handleDeleteOneTask"
      @disableTask="handleDisableTask"
    ></task>
  </v-col>
</template>

<script>
export default {
  name: "Day",
  props: [
    "date",
    "events",
    "history",
    "doneTask",
    "deleteOneTask",
    "disableTask"
  ],
  components: {
    task: () => import("./Task")
  },
  methods: {
    handleDoneTask(task, doneDate = null) {
      if (doneDate) {
        this.$emit("doneTask", task, doneDate);
      } else {
        this.$emit("doneTask", task);
      }
    },
    handleDeleteOneTask(task) {
      this.$emit("deleteOneTask", task);
    },
    handleDisableTask(task) {
      this.$emit("disableTask", task);
    },
    goToPartProfile(task) {
      this.$router.push({
        name: "TaskProfile",
        params: {
          id: task.id,
          uniqueId: task.uniqueId ? task.uniqueId : "N/A",
          taskDate: task.taskDate ? task.taskDate : "N/A"
        }
      });
    }
  }
};
</script>
